import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from "@mui/material/Checkbox";
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {dStr, tStr, unixNow} from './Util';
import {COMM_OK} from './WsR2.js';
import ObsAppBar from './AppBar';
import Trip from './Trip';

const TripList = observer((props) => {
	const [tripOpen, setTripOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function getheader() {
		return t('trips.list');
	}

	function tripListRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('tripListRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'trip') {
			if (msg.op === 'list') {
				if (msg.result === 'OK') {
					let _triplist = {
						last_upd: unixNow(),
						list: msg.data.triplist ? msg.data.triplist : [],
					}

					console.log('tripListRxWs: trip list loading OK!');
					
					_triplist.list.forEach((le) => {
						let j = le.description.length ? JSON.parse(le.description) : le.description;

						if (j.type !== 'doc')
							j = le.description;

						le.description = j;
					});

					gStorage.lists.setTripList(_triplist);
				} else {
					console.error('tripListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else if (msg.op === 'act_toggle') {
				if (msg.result === 'OK') {
					let msg = {
						sess_id: gStorage.conn.sess_id,
						cmd: 'trip',
						op: 'list'
					};

					gStorage.conn.ws.send(msg, tripListRxWs);
				} else {
					console.error('tripListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('tripListRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('tripListRxWs: invalid command', msg.cmd);
			return -1;
		}
	}
	
	function tripClose(changed) {
// 		console.log('tripClose', changed);
		setTripOpen(false);

		if (changed) {
			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'trip',
				op: 'list'
			};

			gStorage.conn.ws.send(msg, tripListRxWs);
		}
	}

	function editTrip(trip) {
		gStorage.trips.setTrip({...trip});
		gStorage.trips.setChanged(false);
		setTripOpen(true);
	}

	function toAddTrip() {
		gStorage.trips.newTrip(true);
		gStorage.trips.setChanged(true);
		setTripOpen(true);
	}

	function tripActiveTgl(trip) {
		console.log('tripActiveTgl', trip);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'act_toggle',
			data: {
				id: trip.id
			}
		};

		gStorage.conn.ws.send(msg, tripListRxWs);
	}

	return (
		<div>
			<ObsAppBar getheader={getheader} add_action={toAddTrip}/>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small' style={{minWidth:500}}>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>ID</TableCell>
							<TableCell>{t('common.name')}</TableCell>
							<TableCell>{t('trips.created')}</TableCell>
							<TableCell padding='checkbox' align='center'>{t('trips.public')}</TableCell>
							<TableCell padding='checkbox' align='center'>{t('trips.active')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.lists.triplist.list.map((trip) => {
							let bg;

							if (trip.id === 0)
								return null;

							bg = trip.user_id === gStorage.conn.user.id ? '#e0f2f1' : '#ffffff';;

							return (
								<TableRow style={{backgroundColor: bg, cursor: 'pointer'}} key={trip.id}>
									<TableCell onClick={editTrip.bind(this, trip)} padding='checkbox'>{trip.id}</TableCell>
									<TableCell onClick={editTrip.bind(this, trip)}>{trip.name}</TableCell>
									<TableCell onClick={editTrip.bind(this, trip)}>{dStr(trip.creat_t) + ' ' + tStr(trip.creat_t)}</TableCell>
									<TableCell onClick={editTrip.bind(this, trip)} padding='checkbox' align='center'>{trip.public_trip ? '\u2713' : ''}</TableCell>
									{ /*<TableCell padding='checkbox' align='center'>{trip.active ? '\u2713' : ''}</TableCell>*/ }
									<TableCell padding='checkbox' align='center'>
										<Checkbox style={{margin:0, padding:6}}
											indeterminate={false}
											checked={trip.active ? true : false}
											onChange={tripActiveTgl.bind(this, trip)}
											color={'primary'}
											disabled={!gStorage.conn.online || (trip.user_id !== gStorage.conn.user.id && gStorage.conn.user.id !== 1)}
										/>
									</TableCell>
								</TableRow>);
							})
						}
					</TableBody>
				</Table>
			</TableContainer>

			<Trip isOpen={tripOpen} handleClose={tripClose} />
		</div>
	);
});

export default TripList;
